module.exports = {"REST_API":"https://beta.simmao.pmpas-bs.eco.br/","SHOW_SEL24H":true};